// The events the ad platforms we buy campaigns on (Facebook, Google Ads) are sent by
// `trackAllAnalyticsEvents`. They are ad platforms rather than analytics tools, so they get the
// events campaigns are built on instead of the firehose. Add a name here to start sending it.
export const AD_TRACKED_EVENTS = new Set([
  'puzzle_started',
  'puzzle_move',
  'puzzle_completion',
  'first_ever_completion',
  'signup_success',
  'daily_email_enabled',
]);

// Renamed on the way out to the name campaigns are set up against. An event absent from this map is
// sent under its own name.
const AD_EVENT_ALIASES: Record<string, string> = {
  signup_success: 'CompleteRegistration',
};

export const adEventName = (event: string): string => AD_EVENT_ALIASES[event] ?? event;
